import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import createHistory from "history/createBrowserHistory";
import { withRouter, Link, useParams } from "react-router-dom";
import { storage } from "../../common/dependencies/store/stoarage";
import * as CryptoJS from "crypto-js";
import {
  getLoginData,
  getFacebookLoginData,
  getvalidateTwitter,
  validateStartupIndia,
} from "./dependencies/action";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import loaderImg from "../../../assets/images/small-loader.gif";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import api from "../../common/dependencies/utils/Api";
import twitterLogo from "../../../assets/svg/twitterSSO.svg";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { useGoogleLogin, hasGrantedAnyScopeGoogle } from "@react-oauth/google";
import LinkedInButton from "../../LinkedInButton";
import { isLoading } from "../../common/dependencies/action/action";

import TwitterLogin from "react-twitter-auth/lib/react-twitter-auth-component.js";
// import { LinkedIn, useLinkedIn } from "react-linkedin-oauth2";
import { useLinkedIn, LinkedInCallback } from "react-linkedin-login-oauth2";
// import TwitterLogin from "react-twitter-login"
// import TwitterLogin from "react-twitter-oauth";

import { BrowserRouter, Route } from "react-router-dom";
import { useCookies } from "react-cookie";
import ReCAPTCHA from "react-google-recaptcha";
import "./styles.scss";
import FormValidator from "./dependencies/common/FormValidator";
import TwitterLoginButton from "./TwitterLoginButton";
// import InputField from "../../common/InputField";
import swal from "sweetalert";
import {
  Typography,
  // TextField,
  Button,
  Stepper,
  Step,
  StepLabel,
} from "@material-ui/core";

import TextField from "@material-ui/core/TextField";
import { USER_PASS, SITE_KEY } from "../../common/constants/actionConstants";
import { display } from "@mui/system";
import InlineError from "../../common/InlineError";

// import { useTranslation } from 'react-i18next'
import {
  FACEBOOK_LOGIN,
  GOOGLE_LOGIN,
  GET_SIGNAL_MENTOR_DATA,
  LINKEDIN_LOGIN,
  LOGIN_DATA,
  LOGIN_DATA_UAT,
  TWITTER_GET_TOKEN,
  TWITTER_VALIDATE_TOKEN,
  STARTUP_INDIA_LOGIN,
  ENCRYPT_PASSWORD_KEY,
} from "../../common/constants/ApplicationUrl";
import FacebookLoginButton from "./FacebookLoginButton";
const LoginForm = (props) => {
  // localStorage.clear();
  // const { t } = useTranslation();
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }

    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };

    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const eye = <FontAwesomeIcon icon={faEye} />;
  const {
    getLoginData,
    // LoginFormData,
    getFacebookLoginData,
    FacebookLoginData,
    getvalidateTwitter,
    getvalidateTwitterData,
    validateStartupIndia,
    // startupIndiaData,
  } = props;

  const [login, setLogin] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [LoginFormData, setLoginFormData] = useState();
  const [data, setData] = useState({});
  const [picture, setPicture] = useState("");
  const [errorMessages, setErrorMessages] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [username, setUsername] = useState("");
  const [passwordnew, setPassword] = useState("");
  const [error, setError] = useState({});
  const [hasInvalidSubmitOccurred, setHasInvalidSubmitOccurred] =
    useState(false);
  const [hasInvalidSubmitOccurred2, setHasInvalidSubmitOccurred2] =
    useState(false);
  const recaptchaRef = useRef(null);
  const [capthaError, setCapthaError] = useState(false);
  const [sentOtp, setSentOtp] = useState(false);
  const [forgotPasswordTemplate, setforgotPasswordTemplate] = useState(false);
  const [facebookusername, setfacebookUserNAme] = useState();
  const [googleLoginData, setGoogleLoginData] = useState(false);
  const [googleEmailData, setGoogleEmailData] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [reloadTest, setReloadTest] = useState(false);
  const [responseRole, setResponserole] = useState(false);
  const fbstate = {
    isLoggedIn: false,
    userID: "",
    name: "",
    email: "",
    picture: "",
  };
  const [facebookLoginData, setFacebookLoginData] = useState(fbstate);
  const resetCaptcha = () => {
    recaptchaRef.current.reset();
  };

  useEffect(() => {
    let presetRoute = window.location.pathname.substring(1);
    if (presetRoute.includes("token=")) {
      let tokenPosition = presetRoute.indexOf("token=");
      let token = presetRoute.slice(tokenPosition + 6, presetRoute.length);
      // let params = { accessToken: token };
      // let params = { accessToken: "eyJhbGciOiJIUzUxMiIsInppcCI6IkRFRiJ9.eNp8jEEKgzAUBe_y1iIKNWhW3brxDr8m1K9JIz-mCOLdG6FrlzMMc2DeGBqGljhRObGsJPR8e2JXjsGjACWTgyGIJ5cxptd9z7RB10qpqmpUVxew-oXj7a9RIpWoA9IcDa-o_hL5uU9-f5AwAA__8.lQ68AunA2OF9IDtfWiHjd23oEinz9e5NOvN39yUZNluBfz7dqXZ4XvRhiUQcdCQPmnZWGSTje5i6Eoa3xc5U7g" };
      // validateStartupIndia(params);
      getStartupIndiaLogin(token);
    }

    //  if(presetRoute === token)
  }, []);
  const getStartupIndiaLogin = (token) => {
    let params = { accessToken: token };

    return api.POST(STARTUP_INDIA_LOGIN, params).then((res) => {
      let startupIndiaData = res.data;
      let { access_token, refresh_token } = startupIndiaData.authResponseDTO;
      if (res.status === 200) {
        localStorage.setItem("accessToken", access_token);
        storage.setUser({
          ...startupIndiaData,
          ...{ access_token, refresh_token },
        });
        // }

        localStorage.setItem("loggedIn", true);
        localStorage.setItem(
          "SavedLoggedInData",
          JSON.stringify(startupIndiaData)
        );
        // storage.setUser({ ...data, ...{ access_token, refresh_token } });
        localStorage.setItem(
          "ProgressReport",
          JSON.stringify(startupIndiaData?.progressReport)
        );
        localStorage.setItem(
          "authData",
          JSON.stringify(startupIndiaData.authResponseDTO)
        );
        // setLoginFormData(response.data);
        localStorage.setItem("setloggedin", "setloggedin");
        if (res?.data?.role == "Startup") {
          if (startupIndiaData.applicationStatus === "SUBMITTED") {
            if (
              history.location.state?.role &&
              history.location.state?.role === "mentor2" &&
              history.location.state?.cohortId
            ) {
              localStorage.setItem("cohortWindow", "cohortsAll");
              history.push({
                pathname: `/cohort-programs/cohortView/${history.location.state?.cohortId}`,
                state: startupIndiaData,
              });
            } else {
              history.push({
                pathname: "/startup-dashboard",
                state: startupIndiaData,
              });
            }
          } else {
            history.push({
              pathname: "/startup-form",
              state: startupIndiaData,
            });
          }
        } else if (startupIndiaData?.role == "Mentor") {
          GetMentorScreen(startupIndiaData);
        } else if (startupIndiaData?.role == "Admin") {
          // alert(LoginFormData?.role)
          history.push({
            pathname: "/dashboard",
            state: startupIndiaData,
          });
        }
      } else {
        swal("Retry Login", "Authentication Failed", "error", {
          closeOnClickOutside: false,
        });
      }
    });
  };
  // useEffect(() => {
  //   if(startupIndiaData !== undefined && startupIndiaData?.length > 0)
  //   {

  //   }
  // }, [startupIndiaData])

  const history = useHistory();
  var twitterRedirect = window.location.origin + "/twitter";
  // theUrl.search = ""; //Remove any params
  // theUrl //as URL object
  // const twitterRedirect = window.location.href.split('?')[0];
  const defaultFormData = {
    username: "",
    password: "",
  };
  const onFacebookLogin = (loginStatus, resultObject) => {
    // alert("test");
    // if (loginStatus === true) {
    //  setfacebookUserNAme(resultObject.user.name)
    //  alert(resultObject.user.name)
    // } else {
    //   alert('Facebook login error');
    // }
  };
  const defaultFormData2 = {
    email_Id: "",
  };

  const [formData, setFormData] = useState(defaultFormData);

  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  // const GetRequestToken=()=>{
  //   // alert(window.location.origin)
  //   api.GET(`${TWITTER_GET_TOKEN}`+window.location.origin+"/login")
  //           .then((response) => {
  //               const { data: { responseCode, data } = {} } = response;
  //               if (response.status === 200) {
  //                 // const { userName } = useParams();

  //                 window.open(
  //                   response.data.authorizationURL,
  //                   "_self"
  //                 );

  //               } else {
  //               }
  //           }).catch(e => {
  //           });
  // }
  const onSuccessTwitter = (response) => {
    response.json().then((body) => {
      alert(JSON.stringify(body));
    });
  };

  const onFailedTwitter = (error) => {
    alert(error);
  };

  const GetMentorScreen = (LoginFormData) => {
    // if(localStorage.getItem("SavedLoggedInData") &&JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role){

    const params = {
      email_id: encryptAES2(LoginFormData.email),
    };
    return api.POST(GET_SIGNAL_MENTOR_DATA, params).then((res) => {
      if (res?.data?.data?.applicationStatus == "PENDING") {
        localStorage.setItem("loggedIn", true);
        localStorage.setItem(
          "SavedLoggedInData",
          JSON.stringify(res?.data?.data)
        );
        history.push({
          pathname: "/become-a-mentor",
          state: res.data.data,
          // state: LoginFormData,
        });
      }
      // else if(res?.data?.data?.applicationStatus === "SUBMITTED"){
      //   localStorage.removeItem("SavedLoggedInData");
      //   localStorage.removeItem("loggedIn");
      //   history.push({
      //     pathname: "/login",
      //   });
      // }
      else if (res?.data?.data?.applicationStatus !== null) {
        if (
          res?.data?.data?.applicationStatus == "REQUESTINFO" ||
          res?.data?.data?.applicationStatus == "VERIFIED" ||
          res?.data?.data?.applicationStatus == "SUBMITTED" ||
          res?.data?.data?.applicationStatus == "REJECTED" ||
          res?.data?.data?.applicationStatus == "UPDATEDINFO"
        ) {
          localStorage.setItem("loggedIn", true);
          localStorage.setItem(
            "SavedLoggedInData",
            JSON.stringify(res.data.data)
          );
        }
        let value = localStorage.getItem("loggedIn");
        //  alert(value)
        // if(LoginData.)

        if (value === null) {
          history.push({
            pathname: "/login",
          });
        } else if (
          history.location.state?.role &&
          history.location.state?.role === "mentor"
        ) {
          history.push({
            pathname: "/cohort-form",
            state: LoginFormData,
          });
        } else if (
          history.location.state?.role &&
          history.location.state?.role === "mentor2" &&
          history.location.state?.cohortId
        ) {
          const newStuff = {
            role: history.location.state?.role,
            cohrotId: history.location.state?.cohortId,
          };
          localStorage.setItem("cohortWindow", "cohortsAll");
          history.push({
            pathname: `/cohort-programs/cohortView/${history.location.state?.cohortId}`,
            state: LoginFormData,
          });
        } else if (
          history.location.state?.role &&
          history.location.state?.role === "mentor3" &&
          history.location.state?.cohortId
        ) {
          localStorage.setItem("cohortWindow", "cohortsAll");
          history.push({
            pathname: `/cohort-programs/cohortView/${history.location.state?.cohortId}`,
            state: LoginFormData,
          });
        } else {
          history.push({
            pathname: "/dashboard",
            state: LoginFormData,
          });
        }
      }
    });
    // }
  };
  const [shouldRender, setShouldRender] = useState(true);
  const [twiiterServiceCalled, setTwiiterServiceCalled] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const auth_verifier = queryParams.get("oauth_verifier");
    const auth_token = queryParams.get("oauth_token");

    if (auth_verifier && auth_token) {
      // twittwertokenvalidate(auth_verifier,auth_token)
      if (twiiterServiceCalled === false) {
        setTwiiterServiceCalled(true);

        getvalidateTwitter(auth_token, auth_verifier).then((response) => {});
      }
      // alert(twiiterServiceCalled)
      if (getvalidateTwitterData) {
        setTwiiterServiceCalled(true);
        if (
          getvalidateTwitterData.role == "Startup" ||
          getvalidateTwitterData.role == "Mentor" ||
          getvalidateTwitterData.role == "Admin"
        ) {
          setLoginFormData(getvalidateTwitterData);
          if (twiiterServiceCalled === true) {
            setTwiiterServiceCalled(false);
            toast.success("Login Successful");
          }
        }
      }
      //   api.GET(`${TWITTER_VALIDATE_TOKEN}oauth_token=`+auth_token+`&oauth_verifier=`+auth_verifier)
      //   .then((response) => {
      //       const { data, status } = response || {};
      //       if (status === 200) {
      //         setLoginFormData(data)
      //       }
      // }).catch(e => {
      // });
    }
  }, [getvalidateTwitterData]);
  const twittwertokenvalidate = (auth_verifier, auth_token) => (dispatch) => {
    dispatch(isLoading(true));
  };
  useEffect(() => {
    setTimeout(() => {
      //remove cache data for sso
      sessionStorage.removeItem("fbssls_");
      localStorage.removeItem("linkedin_oauth2_state");
      removeCookie("user");
      setShouldRender(false);
    }, 1000);
  }, []);

  //FB login status testing for UAT

  // useEffect(()=>{
  //   window.FB.getLoginStatus(function(response) {
  //     var uid = response.authResponse.userID;
  //     var accessToken = response.authResponse.accessToken;
  //     if (response.status === 'connected') {

  //     } else if (response.status === 'not_authorized') {

  //     } else {

  //     }
  //    });
  // },[])
  // refreshPage();
  // useEffect(() => {
  //   if (facebookLogin) {
  //     history.push({
  //       pathname: "/dashboard",
  //       // state: LoginFormData,
  //     });
  //   }
  // }, [facebookLogin]);

  // useEffect(() => {
  //   if (FacebookLoginData) {
  //     if (FacebookLoginData.role == "Startup") {
  //       history.push({
  //         pathname: "/get-a-mentor",
  //         state: FacebookLoginData,
  //       });
  //     } else if (FacebookLoginData.role == "Mentor") {
  //       GetMentorScreen(FacebookLoginData);
  //     } else if (FacebookLoginData.role == "Admin") {
  //       history.push({
  //         pathname: "/dashboard",
  //         state: FacebookLoginData,
  //       });
  //     } else {
  //       history.push({
  //         pathname: "/login",
  //       });
  //     }
  //   }
  // }, [FacebookLoginData]);
  useEffect(() => {
    if (LoginFormData) {
      if (LoginFormData?.role == "Startup") {
        if (LoginFormData?.applicationStatus === "SUBMITTED") {
          if (
            history.location.state?.role &&
            history.location.state?.role === "mentor2" &&
            history.location.state?.cohortId
          ) {
            history.replace({ state: undefined });
            let { access_token, refresh_token } = LoginFormData.authResponseDTO;
            // alert('T hank you for contacting us');
            // if (status) {
            localStorage.setItem("accessToken", access_token);
            storage.setUser({
              ...LoginFormData,
              ...{ access_token, refresh_token },
            });
            // }

            localStorage.setItem("loggedIn", true);
            localStorage.setItem(
              "SavedLoggedInData",
              JSON.stringify(LoginFormData)
            );
            // storage.setUser({ ...data, ...{ access_token, refresh_token } });
            localStorage.setItem(
              "ProgressReport",
              JSON.stringify(LoginFormData?.progressReport)
            );
            localStorage.setItem(
              "authData",
              JSON.stringify(LoginFormData.authResponseDTO)
            );
            // setLoginFormData(response.data);
            localStorage.setItem("setloggedin", "setloggedin");
            localStorage.setItem("cohortWindow", "cohortsAll");
            history.push({
              pathname: `/cohort-programs/cohortView/${localStorage.getItem(
                "clickcohortid"
              )}`,
              // pathname: `/cohort-programs`,
              state: LoginFormData,
            });
          } else {
            history.push({
              pathname: "/startup-dashboard",
              state: LoginFormData,
            });
          }
        } else {
          history.push({
            pathname: "/startup-form",
            state: LoginFormData,
          });
        }
        // swal(
        //   "Please stay tuned, this function will be enabled shortly after the launch of Startup onboarding process.",
        //   { closeOnClickOutside: false }
        // );
        // localStorage.clear();
        // localStorage.removeItem("SavedLoggedInData");
        // localStorage.removeItem("loggedIn");
      } else if (LoginFormData?.role == "Mentor") {
        if (LoginFormData?.applicationStatus === "SUBMITTED") {
          history.push({
            pathname: "/become-a-mentor",
            state: LoginFormData,
          });
        } else {
          if (
            history.location.state?.role &&
            history.location.state?.role === "mentor2" &&
            history.location.state?.cohortId
          ) {
            history.replace({ state: undefined });
            let { access_token, refresh_token } = LoginFormData.authResponseDTO;
            // alert('T hank you for contacting us');
            // if (status) {
            localStorage.setItem("accessToken", access_token);
            storage.setUser({
              ...LoginFormData,
              ...{ access_token, refresh_token },
            });
            // }

            localStorage.setItem("loggedIn", true);
            localStorage.setItem(
              "SavedLoggedInData",
              JSON.stringify(LoginFormData)
            );
            // storage.setUser({ ...data, ...{ access_token, refresh_token } });
            localStorage.setItem(
              "ProgressReport",
              JSON.stringify(LoginFormData?.progressReport)
            );
            localStorage.setItem(
              "authData",
              JSON.stringify(LoginFormData.authResponseDTO)
            );
            // setLoginFormData(response.data);
            // localStorage.setItem("setloggedin", "setloggedin");
            localStorage.setItem("cohortWindow", "cohortsAll");
            history.push({
              pathname: `/cohort-programs/cohortView/${localStorage.getItem(
                "clickcohortid"
              )}`,
              // pathname: `/cohort-programs`,
              state: LoginFormData,
            });
          } else {
            GetMentorScreen(LoginFormData);
          }
        }

        // GetMentorScreen(LoginFormData);
      } else if (LoginFormData?.role == "Admin") {
        if (
          history.location.state?.role !== undefined &&
          history.location.state?.role === "mentor2" &&
          history.location.state?.cohortId
        ) {
          history.replace({ state: undefined });
            let { access_token, refresh_token } = LoginFormData.authResponseDTO;
            localStorage.setItem("accessToken", access_token);
            storage.setUser({
              ...LoginFormData,
              ...{ access_token, refresh_token },
            });
            localStorage.setItem("loggedIn", true);
            localStorage.setItem(
              "SavedLoggedInData",
              JSON.stringify(LoginFormData)
            );
            localStorage.setItem(
              "ProgressReport",
              JSON.stringify(LoginFormData?.progressReport)
            );
            localStorage.setItem(
              "authData",
              JSON.stringify(LoginFormData.authResponseDTO)
            );
            localStorage.setItem("cohortWindow", "cohortsAll");
            history.push({
              pathname: `/cohort-programs/cohortView/${localStorage.getItem(
                "clickcohortid"
              )}`,
              // pathname: `/cohort-programs`,
              state: LoginFormData,
            });
        }
        else{
        // alert(LoginFormData?.role)
        history.push({
          pathname: "/dashboard",
          state: LoginFormData,
        });
      }
      } else {
        history.push({
          pathname: "/login",
        });
      }
    }
  }, [LoginFormData]);

  const validateInput = () => {
    const { username, password } = formData;
    const formStatus = FormValidator.validateLoginForm({
      username,
      password,
    });

    const errors = {
      username: formStatus.username,
      password: formStatus.password,
    };
    setError(errors);
    return !formStatus.hasErrors;
  };
  const responseTwitter = (response) => {};
  const responseFacebook = (response) => {
    setData(response);
    setPicture(response.picture.data.url);
    if (response.accessToken) {
      let fbLoginParam = {
        email: response.email,
        accessToken: response.accessToken,
      };
      api
        .POST(`${FACEBOOK_LOGIN}`, fbLoginParam)
        .then((response) => {
          // const { data: { status, data } = {} } = response;

          if (response.status === 200) {
            if (response.data) {
              if (response.data.role == "Startup") {
                history.push({
                  pathname: "/get-a-mentor",
                  state: response.data,
                });
              } else if (response.data.role == "Mentor") {
                GetMentorScreen(response.data);
              } else if (response.data.role == "Admin") {
                history.push({
                  pathname: "/dashboard",
                  state: response.data,
                });
              } else {
                history.push({
                  pathname: "/login",
                });
              }
            }
          } else {
            // alert("failed");
          }
        })
        .catch((e) => {
          swal("Retry Login", " Authentication Failed", "error", {
            closeOnClickOutside: false,
          });
          return Promise.reject(e);
        });
      setLogin(true);
    } else {
      setLogin(false);
    }
  };
  useEffect(() => {
    let accesstoken = googleLoginData.access_token;
    api
      .GET(
        `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${googleLoginData.access_token}`,
        { mode: "no-cors" }
      )
      .then((res) => {
        // alert(res.data.email)
        if (res !== undefined) {
          setGoogleEmailData(res?.data?.email);
          // if (googleLoginData.access_token && googleEmailData !== false) {
          let googleParams = {
            email: res?.data?.email,
            accessToken: accesstoken,
          };
          api
            .POST(`${GOOGLE_LOGIN}`, googleParams)
            .then((response) => {
              // const { data: { status, data } = {} } = response;

              if (response.status === 200) {
                if (response.data) {
                  if (response.data.role == "Startup") {
                    history.push({
                      pathname: "/get-a-mentor",
                      state: response.data,
                    });
                  } else if (response.data.role == "Mentor") {
                    GetMentorScreen(response.data);
                  } else if (response.data.role == "Admin") {
                    history.push({
                      pathname: "/dashboard",
                      state: response.data,
                    });
                  } else {
                    history.push({
                      pathname: "/login",
                    });
                  }
                }
              } else {
                // alert("failed");
              }
            })
            .catch((e) => {
              swal("Retry Login", " Authentication Failed", "error", {
                closeOnClickOutside: false,
              });
              return Promise.reject(e);
            });

          setLogin(true);
          // } else {
          //   setLogin(false);
          // }
        }
      });
  }, [googleLoginData]);
  const loginGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => setGoogleLoginData(tokenResponse),
  });
  const handleCallBack = (res) => {
    // refreshTokenSetup(res);
  };
  const twitterHandler = (err, data) => {};
  const onSuccess = (data) => {
    // refreshTokenSetup(res);
  };
  // const onSuccessTwitter = () => {
  //   // refreshTokenSetup(res);
  // };
  const onFailureTwitter = () => {
    // refreshTokenSetup(res);
  };
  const onFailure = (res) => {};

  //   const { twitterLogin } = passport.use(new TwitterStrategy({
  //     consumerKey: 'zR6J1QVNGOa5aiHOArgjzAHuV',
  //     consumerSecret: '5hwH58mw9rNlAZgp5dpWlpoMHiQOsbFvYMVfa2x7mrxMwjOKWS',
  //     // callbackURL: ,
  //   }
  //   // function(token, tokenSecret, profile, cb) {
  //   //   User.findOrCreate({ twitterId: profile.id }, function (err, user) {
  //   //     return cb(err, user);
  //   //   });
  //   // }
  // )

  // );
  const { linkedInLogin } = useLinkedIn({
    clientId: "77d154qms6a5ug",
    redirectUri: `${window.location.origin}/linkedin`,
    scope: "r_liteprofile r_emailaddress",
    onSuccess: (code) => {
      let accessToken = {
        email: "",
        accessToken: code,
      };
      api
        .POST(`${LINKEDIN_LOGIN}`, accessToken)
        .then((response) => {
          if (response.status === 200) {
            if (response.data) {
              if (response.data.role == "Startup") {
                history.push({
                  pathname: "/get-a-mentor",
                  state: response.data,
                });
              } else if (response.data.role == "Mentor") {
                GetMentorScreen(response.data);
              } else if (response.data.role == "Admin") {
                history.push({
                  pathname: "/dashboard",
                  state: response.data,
                });
              } else {
                history.push({
                  pathname: "/login",
                });
              }
            }
          } else {
          }
        })
        .catch((e) => {
          swal("Retry Login", " Authentication Failed", "error", {
            closeOnClickOutside: false,
          });
          return Promise.reject(e);
        });
      setLogin(true);
    },
  });

  // const parameters = {
  //     'grant_type': 'authorization_code',
  //     'code': code,
  //     'redirect_uri': 'http://localhost:3000/linkedin',
  //     'client_id': '77d154qms6a5ug',
  //     'client_secret': '4aPiETYyKQkNMKW7',
  //   };
  //   const params = new URLSearchParams();
  // params.append('grant_type', 'authorization_code');
  // params.append('code', code);
  // params.append('redirect_uri', 'http://localhost:3000/linkedin');
  // params.append('client_id', '77d154qms6a5ug');
  // params.append('client_secret', '4aPiETYyKQkNMKW7');
  //   api.POST_URLENCODED(
  //       `https://www.linkedin.com/oauth/v2/authorization`,params)
  //     .then(response => {
  //     })
  //     .catch(err => {
  //     })
  //       },
  //       onError: (error) => {
  //       },
  // useEffect(()=>{
  //   sessionStorage.removeItem('fbssls_');
  //   localStorage.removeItem('linkedin_oauth2_state');
  // },[])

  //   useEffect(()=>{
  //     window.addEventListener('message', handlePostMessage);
  //   },[])
  //  const handlePostMessage = (event) => {
  //   if(event?.data?.code){
  //     const params = {
  //       accessToken: event?.data?.code,
  //       email: "",
  //     }
  //       api.POST(`${LINKEDIN_LOGIN}`,params)
  //         .then(response => {
  //         })
  //         .catch(err => {
  //         })
  //           }
  //         };

  const requestProfile = () => {
    var oauthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77d154qms6a5ug&scope=r_liteprofile&state=123456&redirect_uri=http://localhost:3000/callback`;
    var width = 450,
      height = 730,
      left = window.screen.width / 2 - width / 2,
      top = window.screen.height / 2 - height / 2;

    window.open(
      oauthUrl,
      "Linkedin",
      "menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=" +
        width +
        ", height=" +
        height +
        ", top=" +
        top +
        ", left=" +
        left
    );
  };
  const handleLinkedInSuccess = (data) => {};

  const handleLinkedInFailure = (error) => {};

  // const validateInputforgotpassEmail = () => {
  //   const { email_Id } = formData;
  //   const formStatus = FormValidator.validateForgotPasswordForm({
  //     email_Id,
  //   });

  //   const errors = {
  //     email_Id: formStatus.email_Id,
  //   };
  //   setError(errors);
  //   return !formStatus.hasErrors;
  // };

  const onBlur = () => {
    validateInput();
    // validateInputforgotpassEmail();
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const auth_verifier = queryParams.get("oauth_verifier");
    const auth_token = queryParams.get("oauth_token");

    if (auth_verifier && auth_token) {
      // twittwertokenvalidate(auth_verifier,auth_token)
      if (twiiterServiceCalled === false) {
        setTwiiterServiceCalled(true);

        getvalidateTwitter(auth_token, auth_verifier).then((response) => {});
      }
      // alert(twiiterServiceCalled)
      if (getvalidateTwitterData) {
        setTwiiterServiceCalled(true);
        if (
          getvalidateTwitterData.role == "Startup" ||
          getvalidateTwitterData.role == "Mentor" ||
          getvalidateTwitterData.role == "Admin"
        ) {
          setLoginFormData(getvalidateTwitterData);
          if (twiiterServiceCalled === true) {
            setTwiiterServiceCalled(false);
            toast.success("Login Successful");
          }
        }
      }
      //   api.GET(`${TWITTER_VALIDATE_TOKEN}oauth_token=`+auth_token+`&oauth_verifier=`+auth_verifier)
      //   .then((response) => {
      //       const { data, status } = response || {};
      //       if (status === 200) {
      //         setLoginFormData(data)
      //       }
      // }).catch(e => {
      // });
    }
  }, [getvalidateTwitterData]);

  const GetRequestToken = () => {
    api
      .GET(`${TWITTER_GET_TOKEN}` + window.location.origin + "/login")
      .then((response) => {
        const { data: { responseCode, data } = {} } = response;
        if (response.status === 200) {
          window.open(response.data.authorizationURL, "_self");
        } else {
        }
      })
      .catch((e) => {});
  };

  const errors = {
    uname: "invalid username",
    pass: "invalid password",
  };

  const handleInputChange = (e, name) => {
    // alert(name)
    const { value } = e.target;
    // alert(value)
    setFormData((user) => {
      return { ...user, [name]: value };
    });
    // validateInput();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // localStorage.removeItem("cohortApplication");
    // localStorage.removeItem("cohortMentors");
    // alert("test")
    if (!validateInput()) {
      setHasInvalidSubmitOccurred(true);
      toast.error(USER_PASS);
    } else {
      // const recaptchaValue = recaptchaRef.current.getValue()
      // if (recaptchaValue === '') {
      //   setCapthaError(true)
      // } else {
      //   setCapthaError(false)
      // const recaptchaValue = recaptchaRef.current.getValue();
      // if (recaptchaValue === "") {
      //   setCapthaError(true);
      // }
      // else {
        const { username, password } = formData;
        const loginDetails = {
          username: username,
          password: password,
        };
        // setLoading(true);

      // const paramsData = {
      //   email: username,
      // };

      // axios({
      //   url: ENCRYPT_PASSWORD_KEY,
      //   method: "POST",
      //   data: paramsData,
      // })
      //   .then((response) => {
      // console.log("new api", response.data?.data,"recaptchaValue",recaptchaValue);
      api
        .POST(LOGIN_DATA, {
          username: username,
          password: password,
          // password: encryptAES2(password, response.data?.data?.salt),
          // secret: recaptchaValue,
        })
          .then((response) => {
          //         api
          // .POST(LOGIN_DATA, {
          //       username: username,
          //       // password:password,
          //     password: encryptAES2(password, response.data?.data?.salt),
          //     secret: recaptchaValue,
          // })
          // .then((response) => {
            // login({
            //   username: username,
            //   password: encryptAES2(password, response.data?.data?.salt),
            //   secret: recaptchaValue,
            // }).
            // then((data) => {
              const { status = false, message } = response || {};
              if(status == false){
                              swal(
                  "Retry Login",
                  history.location.state === "Startup"
                    ? "Please Enter Your Startup DPIIT ID Only"
                    : history.location.state === "Mentor"
                    ? "Please Enter Your Mentor Credentials Only"
                    : "Invalid Username or Password",
                  "error",
                  { closeOnClickOutside: false }
                );
              }
              if (status) {
     setResponserole(response.data.role);
  
            const { data, status } = response || {};
            if (
              status === 200 &&
              (history.location.state !== undefined
                ? history.location.state === data.role
                : true)
            ) {
              history.replace({ state: undefined });
              let { access_token, refresh_token } = data.authResponseDTO;
              // alert('T hank you for contacting us');
              if (status) {
                localStorage.setItem("accessToken", access_token);
                storage.setUser({
                  ...data,
                  ...{ access_token, refresh_token },
                });
              }
              localStorage.setItem("loggedIn", true);
              localStorage.setItem("SavedLoggedInData", JSON.stringify(data));
              // storage.setUser({ ...data, ...{ access_token, refresh_token } });
              localStorage.setItem(
                "ProgressReport",
                JSON.stringify(data?.progressReport)
              );
              localStorage.setItem(
                "authData",
                JSON.stringify(data.authResponseDTO)
              );
              setLoginFormData(response.data);
              localStorage.setItem("setloggedin", "setloggedin");

              // return response ;
            } else if (
              history.location.state?.role &&
              history.location.state?.role === "mentor" &&
              response.data.role === "Mentor"
            ) {
              localStorage.setItem("loggedIn", true);
              localStorage.setItem("SavedLoggedInData", JSON.stringify(data));
              setLoginFormData(response.data);
            } else if (
              history.location.state?.role &&
              history.location.state?.role === "mentor2" &&
              (response.data.role === "Mentor" ||
                response.data.role === "Startup" || response.data.role === "Admin") &&
              history.location.state?.cohortId
            ) {
              localStorage.setItem("loggedIn", true);
              localStorage.setItem("SavedLoggedInData", JSON.stringify(data));
              setLoginFormData(response.data);
            } else if (
              history.location.state?.role &&
              history.location.state?.role === "mentor3" &&
              response.data.role === "Mentor" &&
              history.location.state?.cohortId
            ) {
              localStorage.setItem("loggedIn", true);
              localStorage.setItem("SavedLoggedInData", JSON.stringify(data));
              setLoginFormData(response.data);
            } else {
              // dispatch(isLoading(false));
              if (
                history.location.state?.role &&
                history.location.state?.role === "mentor"
              ) {
                setLoading(false);
                swal(
                  "Retry",
                  `Only Mentor can Create a Cohort.\nPlease Login with Mentor Credentials`,
                  "error",
                  {
                    closeOnClickOutside: false,
                  }
                );
                return { status: false };
              } else {
                setLoading(false);
                swal(
                  "Retry Login",
                  history.location.state === "Startup"
                    ? "Please Enter Your Startup DPIIT ID Only"
                    : history.location.state === "Mentor"
                    ? "Please Enter Your Mentor Credentials Only"
                    : "Invalid Username or Password",
                  "error",
                  { closeOnClickOutside: false }
                );

                return { status: false };
              }

              // swal(
              //   "Retry Login",
              //   history.location.state === "Startup"
              //     ? "Please Enter Your Startup DPIIT ID Only"
              //     : history.location.state === "Mentor"
              //     ? "Please Enter Your Mentor Credentials Only"
              //     : "Invalid Username or Password",
              //   "error",
              //   { closeOnClickOutside: false }
              // );

              // // toast.error("Invalid Username or Password");
              // return { status: false };
            }
              } else {
                resetCaptcha();
              }
            });
          // })


        // api
        //   .POST(LOGIN_DATA_UAT, loginDetails)
        //   .then((response) => {
        //     setResponserole(response.data.role);
  
        //     const { data, status } = response || {};
        //     if (
        //       status === 200 &&
        //       (history.location.state !== undefined
        //         ? history.location.state === data.role
        //         : true)
        //     ) {
        //       history.replace({ state: undefined });
        //       let { access_token, refresh_token } = data.authResponseDTO;
        //       // alert('T hank you for contacting us');
        //       if (status) {
        //         localStorage.setItem("accessToken", access_token);
        //         storage.setUser({ ...data, ...{ access_token, refresh_token } });
        //       }
        //       localStorage.setItem("loggedIn", true);
        //       localStorage.setItem("SavedLoggedInData", JSON.stringify(data));
        //       // storage.setUser({ ...data, ...{ access_token, refresh_token } });
        //       localStorage.setItem(
        //         "ProgressReport",
        //         JSON.stringify(data?.progressReport)
        //       );
        //       localStorage.setItem(
        //         "authData",
        //         JSON.stringify(data.authResponseDTO)
        //       );
        //       setLoginFormData(response.data);
        //       localStorage.setItem("setloggedin", "setloggedin");
  
        //       // return response ;
        //     } else if (
        //       history.location.state?.role &&
        //       history.location.state?.role === "mentor" &&
        //       response.data.role === "Mentor"
        //     ) {
        //       localStorage.setItem("loggedIn", true);
        //       localStorage.setItem("SavedLoggedInData", JSON.stringify(data));
        //       setLoginFormData(response.data);
        //     } else if (
        //       history.location.state?.role &&
        //       history.location.state?.role === "mentor2" &&
        //       (response.data.role === "Mentor" ||
        //         response.data.role === "Startup") &&
        //       history.location.state?.cohortId
        //     ) {
        //       localStorage.setItem("loggedIn", true);
        //       localStorage.setItem("SavedLoggedInData", JSON.stringify(data));
        //       setLoginFormData(response.data);
        //     } else if (
        //       history.location.state?.role &&
        //       history.location.state?.role === "mentor3" &&
        //       response.data.role === "Mentor" &&
        //       history.location.state?.cohortId
        //     ) {
        //       localStorage.setItem("loggedIn", true);
        //       localStorage.setItem("SavedLoggedInData", JSON.stringify(data));
        //       setLoginFormData(response.data);
        //     } else {
        //       // dispatch(isLoading(false));
        //       if (
        //         history.location.state?.role &&
        //         history.location.state?.role === "mentor"
        //       ) {
        //         setLoading(false);
        //         swal(
        //           "Retry",
        //           `Only Mentor can Create a Cohort.\nPlease Login with Mentor Credentials`,
        //           "error",
        //           {
        //             closeOnClickOutside: false,
        //           }
        //         );
        //         return { status: false };
        //       } else {
        //         setLoading(false);
        //         swal(
        //           "Retry Login",
        //           history.location.state === "Startup"
        //             ? "Please Enter Your Startup DPIIT ID Only"
        //             : history.location.state === "Mentor"
        //             ? "Please Enter Your Mentor Credentials Only"
        //             : "Invalid Username or Password",
        //           "error",
        //           { closeOnClickOutside: false }
        //         );
  
        //         return { status: false };
        //       }
  
        //       // swal(
        //       //   "Retry Login",
        //       //   history.location.state === "Startup"
        //       //     ? "Please Enter Your Startup DPIIT ID Only"
        //       //     : history.location.state === "Mentor"
        //       //     ? "Please Enter Your Mentor Credentials Only"
        //       //     : "Invalid Username or Password",
        //       //   "error",
        //       //   { closeOnClickOutside: false }
        //       // );
  
        //       // // toast.error("Invalid Username or Password");
        //       // return { status: false };
        //     }
        //   })
  
        //   .catch(() => {
        //     swal(
        //       "Authentication Failed",
        //       " Invalid Username or Password",
        //       "error",
        //       {
        //         closeOnClickOutside: false,
        //       }
        //     );
        //     setLoading(false);
        //     return Promise.reject(e);
        //   });
      // }
     

      // getLoginData(loginDetails).then((data) => {
      //   // alert("Test")
      //   if (LoginFormData) {
      //     // alert(LoginFormData.name)
      //     history.push({
      //       pathname: "/get-a-mentor",
      //       state: LoginFormData,
      //     });
      //   } else {
      //   }
      // });
      // }
    }

    // getLoginData(loginDetails);
  };
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);

    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);

    // let aesText = iv + "::" + salt + "::" + ciphertext;
    return btoa(text);
  };
  const handleForgotSubmit = (e) => {
    e.preventDefault();
    // if (!validateInputforgotpassEmail()) {
    //   setHasInvalidSubmitOccurred2(true);
    // } else {
    //   const { email_Id } = formData;
    //   localStorage.setItem("forgotPasswordEmail", email_Id);
    //   setSentOtp(true);
    //   if (sentOtp) {
    //   }
    // }
    setSentOtp(true);
    setforgotPasswordTemplate(false);
  };

  // Generate JSX code for error message
  const renderErrorMessage = (name) => {
    return (
      <div>
        {name === "uname" ? (
          <div className="login-error-msg">{error.username}</div>
        ) : name === "password" ? (
          <div className="login-error-msg">{error.password}</div>
        ) : (
          <div className="login-error-msg">This is required field *</div>
        )}
      </div>
    );
  };

  // const renderForgotPasswordOTPform = (
  //   <div className="form">
  //     <div className="loginformouter row">
  //       <div className="loginformnew col-md-6 col-sm-12">
  //         <form onSubmit={(e) => handleForgotSubmit(e)}>
  //           <TextField
  //             id="otp"
  //             label="Enter OTP "
  //             variant="outlined"
  //             fullWidth
  //             margin="normal"
  //             name="otp"
  //             value={formData.otp}
  //             onChange={handleInputChange2}
  //             error={error.email_Id}
  //             onBlur={onBlur}
  //             hasInvalidSubmitOccurred={hasInvalidSubmitOccurred2}
  //           />

  //           <TextField
  //             id="newpassword"
  //             label="Enter New Password "
  //             variant="outlined"
  //             fullWidth
  //             margin="normal"
  //             name="newpassword"
  //             value={formData.newpassword}
  //             onChange={handleInputChange2}
  //             error={error.email_Id}
  //             onBlur={onBlur}
  //             hasInvalidSubmitOccurred={hasInvalidSubmitOccurred2}
  //           />

  //           <TextField
  //             id="confirmpassword"
  //             label="Enter Confirm Password "
  //             variant="outlined"
  //             fullWidth
  //             margin="normal"
  //             name="confirmpassword"
  //             value={formData.confirmpassword}
  //             onChange={handleInputChange2}
  //             error={error.email_Id}
  //             onBlur={onBlur}
  //             hasInvalidSubmitOccurred={hasInvalidSubmitOccurred2}
  //           />

  //           {/* {renderErrorMessage("email_Id")}
  //           <div className="pass-wrapper"> </div>

  //           {renderErrorMessage("password")} */}

  //           <Button className="login-btn" type="submit">
  //             RESET PASSWORD
  //           </Button>

  //           <div className="credentialheader1">Do you want to close?</div>
  //           <div
  //             className="forgotpasslogin"
  //             style={{ cursor: "pointer" }}
  //             onClick={() => {
  //               setforgotPasswordTemplate(false);
  //               setSentOtp(false);
  //             }}
  //           >
  //             Login
  //           </div>

  //           <div className="ssomaindiv outerssomain card">
  //             <div className="ssodiv row">
  //               <p
  //                 className="col-12"
  //                 style={{ fontSize: "19px", fontFamily: "Montserrat" }}
  //               >
  //                 Login Via SSO
  //               </p>
  //               <div
  //                 className="row col-12"
  //                 style={{ width: "33%", height: "40%", marginTop: "-5%" }}
  //               >
  //                 <div className="col-4 googlesso"></div>
  //                 <div className="col-4 linkedinsso"></div>

  //                 {/* {login &&
  //           <Image src={picture} roundedCircle />
  //         } */}
  //                 {/* <div className="col-4">
  //                 <FacebookLogin
  //             appId="365400755485783"
  //             autoLoad={true}
  //             fields="name,email,picture"
  //             scope="public_profile,user_friends"
  //             callback={responseFacebook}
  //             icon="fa-facebook" />
  //             </div> */}
  //               </div>
  //             </div>
  //           </div>
  //         </form>
  //       </div>
  //       <div className="col-md-6 col-sm-12" style={{ height: "435px" }}>
  //         <div style={{ display: "inline-block", justifyContent: "center" }}>
  //           <p
  //             // style={{
  //             //   color: "#9988bf",
  //             //   fontWeight: 600,
  //             //   fontSize: "18px",
  //             //   fontFamily: "Montserrat",
  //             // }}
  //             className="credentialheader2"
  //           >
  //             Don't Have Startup India Login Credentials Yet?
  //           </p>
  //           <div
  //             style={
  //               {
  //                 // justifyContent: "center", marginLeft: "25%",
  //                 // marginTop: "13px"
  //               }
  //             }
  //           >
  //             <div
  //               className="createaccountbtn top-btn"
  //               style={{ cursor: "pointer" }}
  //               onClick={() => {
  //                 // window.location.href =
  //                 //   "https://www.startupindia.gov.in/content/sih/en/registration.html";
  //                 window.open(
  //                   "https://www.startupindia.gov.in/content/sih/en/registration.html",
  //                   "_blank"
  //                 );
  //               }}
  //             >
  //               <a
  //                 className="link "
  //                 href="https://www.startupindia.gov.in/content/sih/en/registration.html"
  //                 target="_blank"
  //               >
  //                 {" "}
  //                 CREATE AN ACCOUNT
  //               </a>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="logingraphicdiv"></div>
  //       </div>
  //     </div>
  //   </div>
  // );

  // // JSX code for login form
  // const renderForgotPasswordForm = (
  //   <div className="form">
  //     <div className="loginformouter row">
  //       <div className="loginformnew col-md-6 col-sm-12">
  //         <form onSubmit={(e) => handleForgotSubmit(e)}>
  //           <TextField
  //             id="email_Id"
  //             label="Email ID "
  //             variant="outlined"
  //             fullWidth
  //             margin="normal"
  //             name="email_Id"
  //             value={formData.email_Id}
  //             onChange={handleInputChange2}
  //             error={error.email_Id}
  //             onBlur={onBlur}
  //             hasInvalidSubmitOccurred={hasInvalidSubmitOccurred2}
  //           />

  //           {/* {renderErrorMessage("email_Id")}
  //           <div className="pass-wrapper"> </div>

  //           {renderErrorMessage("password")} */}

  //           <Button
  //             className="login-btn"
  //             type="submit"
  //             // onClick={() => {
  //             //   setSentOtp(true);
  //             // }}
  //           >
  //             SEND OTP
  //           </Button>

  //           <div className="credentialheader1">Do you want to close?</div>
  //           <div
  //             className="forgotpasslogin"
  //             style={{ cursor: "pointer" }}
  //             onClick={() => {
  //               setforgotPasswordTemplate(false);
  //             }}
  //           >
  //             Login
  //           </div>
  //           <div className="ssomaindiv outerssomain card">
  //             <div className="ssodiv row">
  //               <p
  //                 className="col-12"
  //                 style={{ fontSize: "19px", fontFamily: "Montserrat" }}
  //               >
  //                 Login Via SSO
  //               </p>
  //               <div
  //                 className="row col-12"
  //                 style={{ width: "33%", height: "40%", marginTop: "-5%" }}
  //               >
  //                 <div className="col-4 googlesso"></div>
  //                 <div className="col-4 linkedinsso"></div>
  //                 <div className="col-4 facebooksso">
  //                   {/* <div className="fb-login-button" data-width="" data-size="small" data-button-type="login_with" data-layout="rounded" data-auto-logout-link="false" data-use-continue-as="false"></div> */}
  //                   {/* <div class="fb-login-button" data-width="" data-size="small" data-button-type="login_with" data-layout="rounded" data-auto-logout-link="false" data-use-continue-as="false"></div> */}
  //                   {/* <div class="fb-login-button" data-width="" data-size="large" data-button-type="continue_with" data-layout="default" data-auto-logout-link="false" data-use-continue-as="false"></div> */}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </form>
  //       </div>
  //       <div className="col-md-6 col-sm-12" style={{ height: "435px" }}>
  //         <div style={{ display: "inline-block", justifyContent: "center" }}>
  //           <p
  //             // style={{
  //             //   color: "#9988bf",
  //             //   fontWeight: 600,
  //             //   fontSize: "18px",
  //             //   fontFamily: "Montserrat",
  //             // }}
  //             className="credentialheader2"
  //           >
  //             Don't Have Startup India Login Credentials Yet?
  //           </p>
  //           <div
  //             style={
  //               {
  //                 // justifyContent: "center", marginLeft: "25%",
  //                 // marginTop: "13px"
  //               }
  //             }
  //           >
  //             <div
  //               className="createaccountbtn"
  //               style={{ cursor: "pointer" }}
  //               onClick={() => {
  //                 // window.location.href =
  //                 //   "https://www.startupindia.gov.in/content/sih/en/registration.html";
  //                 window.open(
  //                   "https://www.startupindia.gov.in/content/sih/en/registration.html",
  //                   "_blank"
  //                 );
  //               }}
  //             >
  //               <a
  //                 className="link "
  //                 href="https://www.startupindia.gov.in/content/sih/en/registration.html"
  //                 target="_blank"
  //               >
  //                 {" "}
  //                 CREATE AN ACCOUNT
  //               </a>
  //             </div>
  //           </div>
  //         </div>
  //         <div className="logingraphicdiv"></div>
  //       </div>
  //     </div>
  //   </div>
  // );
  // JSX code for forgot Password form
  const renderForm = (
    <div className="form">
      <div className="loginformouter row">
        <div
          // style={{ width: "50%" }}
          className="loginformnew col-md-6 col-sm-12"
        >
          <form onSubmit={handleSubmit}>
            <TextField
              id="user_name"
              label="User Name"
              variant="outlined"
              // placeholder="Enter Your Username"
              fullWidth
              margin="normal"
              name="username"
              value={formData.username}
              onChange={(e) => handleInputChange(e, "username")}
              error={error.username}
              onBlur={onBlur}
              hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
            />

            {renderErrorMessage("uname")}
            <div className="pass-wrapper">
              {" "}
              <TextField
                //  className="login-password"
                id="password"
                variant="outlined"
                label="Password"
                fullWidth
                margin="normal"
                // placeholder="Password"
                name="password"
                value={formData.password}
                type={passwordShown ? "text" : "password"}
                onChange={(e) => handleInputChange(e, "password")}
                error={error.username}
                onBlur={onBlur}
                hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
              />
              {/* <div className="newuserTooltip"> */}
              <i
                style={{ display: passwordShown === true ? "block" : "none" }}
                onClick={togglePasswordVisiblity}
              >
                {eye}
              </i>
              <i
                class="fa fa-eye-slash"
                style={{ display: passwordShown === false ? "block" : "none" }}
                onClick={togglePasswordVisiblity}
              ></i>
              {/* {passwordShown===true?( <span className="tooltiptext  tooltip-bottom" >
                                  Click to Show Password
                               </span>):( <span className="tooltiptext  tooltip-bottom" >
                                  Click to hide Password
                               </span>)}
            </div> */}
            </div>
              <div className="captcha-field">
          {/* <ReCAPTCHA ref={recaptchaRef} sitekey={SITE_KEY} /> */}
        </div>
            {/* <TextField
            id="password"
            label="Password"
            variant="outlined"
            // placeholder="Enter Password"
            fullWidth
            margin="normal"
            type="password"
            name="password"
            value={formData.password}
            onChange={(e) => handleInputChange(e, "password")}
            error={error.username}
            onBlur={onBlur}
            hasInvalidSubmitOccurred={hasInvalidSubmitOccurred}
          /> */}

            {renderErrorMessage("password")}
            {capthaError && (
              <div className="login-error-msg">Please verify the captcha *</div>
            )}
            {/* <div className="button-container">
            <input type="submit" />
          </div> */}
            {/* <div className="col-12 col-lg-7">
                <div className="captcha-field">
                  <ReCAPTCHA ref={recaptchaRef} sitekey={SITE_KEY} />
                  {capthaError && 
                    renderErrorMessage("capcha")
                  }
                </div>
              </div> 
          
           */}
            <div className="newuserTooltip">
              <Button className="login-btn" type="submit">
                login
              </Button>
              {isLoading && (
                <div className="loader-frame">
                  <div className="loader-container">
                    <img src={loaderImg} />
                  </div>
                </div>
              )}
              <span className="tooltiptext  tooltip-bottom login-01">
                Click to Login or Apply
              </span>
            </div>
            <div className="credentialheader1">
              Please Use Your Startup India Credentials To Login or Apply
            </div>
            <div className="newuserTooltip">
              <div
                className="forgotpasslogin"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // setforgotPasswordTemplate(true);
                  // window.open("https://www.startupindia.gov.in/", "_blank");
                  window.open(
                    "https://www.startupindia.gov.in/content/sih/en/reset-password.html?key=maarg",
                    "_blank"
                  );
                }}
              >
                Forgot Password?
              </div>
              <span
                className="tooltiptext  tooltip-bottom"
                style={{ width: "350px", height: "auto", left: "30%" }}
              >
                You will be redirected to Startup India Portal.<br></br> Please
                click on 'Login &gt; Unable to Login' to reset your password.
              </span>
            </div>
          </form>
          <div className="ssomaindiv outerssomain card">
            <div className="ssodiv row">
              <p
                className="col-12"
                style={{
                  fontSize: "18px",
                  paddingTop: "15px",
                  fontFamily: "Montserrat",
                }}
              >
                Login Via SSO
              </p>
              <div
                className="row d-flex justify-content-center align-items-center"
                style={{ width: "100%", height: "60px" }}
              >
                <div className="col-3 iconSso newuserTooltip">
                  <button className="googlesso" onClick={loginGoogle} />
                  <span
                    className="tooltiptext  tooltip-bottom"
                    style={{ left: "19px", top: "50px", width: "150px" }}
                  >
                    Login with Google
                  </span>
                </div>
                <div className="col-3 iconSso newuserTooltip">
                  {/* <button className="linkedinsso" onClick={requestProfile} /> */}
                  <button className="linkedinsso" onClick={linkedInLogin} />
                  <span
                    className="tooltiptext  tooltip-bottom"
                    style={{ left: "22px", top: "50px", width: "150px" }}
                  >
                    Login with LinkedIn
                  </span>
                </div>
                <div className="col-3 fbButtonWrapper iconSso p-0 mr-0 newuserTooltip">
                  <FacebookLogin
                    appId="502040338260711"
                    autoLoad={false}
                    fields="name,email,picture"
                    scope="public_profile,user_friends,email"
                    callback={responseFacebook}
                    className="facebooksso"
                    render={(renderProps) => (
                      <button
                        className="facebooksso"
                        onClick={renderProps.onClick}
                      ></button>
                      // <button className="facebooksso" onClick={renderProps.onClick}></button>
                    )}
                  />
                  <span
                    className="tooltiptext  tooltip-bottom"
                    style={{ left: "9px", top: "50px", width: "150px" }}
                  >
                    Login with Facebook
                  </span>
                </div>
                {/* <div className="col-4 iconSso2">
                  <button className="twittersso" onClick={linkedInLogin} />
                </div> */}
                <div className="col-3 iconSso ">
                  {/* <TwitterLogin
      authCallback={twitterHandler}
      // onSuccess={onSuccessTwitter}
      // onFailure={onFailureTwitter}
      // loginUrl={"https://uat-nmp-api.startupindia.gov.in/v1/validateTwitterLogin"}
//       clientid : dVREczlfNW9tdWlmaE5MRG5yemQ6MTpjaQ
// clientSecret : VMfOEZYL98FtzfQhbiIGVaCP74OcBw-m7IMKW0_75wHgrGwfR9
      consumerKey={"zR6J1QVNGOa5aiHOArgjzAHuV"}
      consumerSecret={"5hwH58mw9rNlAZgp5dpWlpoMHiQOsbFvYMVfa2x7mrxMwjOKWS"}
      children={<TwitterLoginButton/>}
      style={{backgroundColor:"transparent"}}
    /> */}
                  {/* <TwitterLogin
      authCallback={twitterHandler}
      consumerKey={"zR6J1QVNGOa5aiHOArgjzAHuV"}
      consumerSecret={"5hwH58mw9rNlAZgp5dpWlpoMHiQOsbFvYMVfa2x7mrxMwjOKWS"}
      requestTokenUrl={"http://localhost:8090/getAuthToken"}
      accessTokenUrl={"https://api.twitter.com/oauth/access_token"}
      children={<TwitterLoginButton/>} */}

                  {/* <TwitterLogin loginUrl="http://localhost:4000/api/v1/auth/twitter"
                      onFailure={onFailedTwitter}
                      onSuccess={onSuccessTwitter}
                      authCallback={twitterHandler}
                      requestTokenUrl={GetRequestToken}//"http://localhost:8090/getAuthToken"
                      showIcon={true}
                      children={<TwitterLoginButton/>}
                      /> */}
                  <div className="col-3 iconSso3 newuserTooltip">
                    <button className="twittersso" onClick={GetRequestToken} />
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ left: "0px", top: "50px", width: "150px" }}
                    >
                      Login with Twitter
                    </span>
                  </div>
                  {/* <button
                        className="facebooksso"
                        onClick={GetRequestToken}
                      ></button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-sm-12" style={{ height: "435px" }}>
          <div style={{ display: "inline-block", justifyContent: "center" }}>
            <p
              // style={{
              //   color: "#9988bf",
              //   fontWeight: 600,
              //   fontSize: "18px",
              //   fontFamily: "Montserrat",
              // }}
              className="credentialheader2"
            >
              Don't Have Startup India Login Credentials Yet?
            </p>
            <div
              style={
                {
                  // justifyContent: "center", marginLeft: "25%",
                  // marginTop: "13px"
                }
              }
            >
              <div
                className="createaccountbtn newuserTooltip"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // window.location.href =
                  //   "https://www.startupindia.gov.in/content/sih/en/registration.html";
                  window.open(
                    "https://www.startupindia.gov.in/content/sih/en/registration.html",
                    "_blank"
                  );
                }}
              >
                <a
                  className="link createaccountbtnText"
                  href="https://www.startupindia.gov.in/content/sih/en/registration.html"
                  target="_blank"
                >
                  {" "}
                  CREATE AN ACCOUNT
                  {/* { t('CREATE_AN_ACCOUNT')} */}
                </a>
                <span className="tooltiptext createaccount  tooltip-bottom">
                  Create An Account
                </span>
              </div>
            </div>
          </div>
          <div className="logingraphicdiv"></div>
        </div>
      </div>
    </div>
  );

  return (
    <div id="grad1" className="loginPage">
      <div className="app">
        <div className="login-form">
          <h3 className="sub-heading">MAARG Portal by Startup India</h3>
          <h2 className="heading">LOGIN</h2>
          {isSubmitted ? (
            <div>User is successfully logged in</div>
          ) : (
            // forgotPasswordTemplate ? (
            //   // renderForgotPasswordForm
            // ) : sentOtp ? (
            //   renderForgotPasswordOTPform
            // ) :
            renderForm
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //   setLoginSuccess(state.LoginpageReducer.getLoginData.data)
  return {
    // LoginFormData: state.LoginpageReducer.getLoginData.data,
    getvalidateTwitterData:
      state.LoginpageReducer.getTwitterLoginData &&
      state.LoginpageReducer.getTwitterLoginData.data,
    FacebookLoginData: state.LoginpageReducer.getFacebookLoginData.data,
    // startupIndiaData: state.LoginpageReducer.getStartupIndiaLoginData,
  };
};
export default connect(mapStateToProps, {
  getLoginData,
  getFacebookLoginData,
  getvalidateTwitter,
  validateStartupIndia,
})(withRouter(LoginForm));
